module.exports = __webpack_public_path__ + "static/esferasaude.c69021d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/esferasaude.jpg
// module id = 530
// module chunks = 56635243537030